const SHEET_COLUMNS = [
	{ header: "Apellidos y nombre", key: "nombreApellidos", width: 28 },
	{ header: "Puede fichar", key: "puedeFichar", width: 14 },
	{ header: "Nombre de la empresa", key: "empresa", width: 28 },
	{ header: "ID Nacional", key: "idNacional", width: 16 },
	{ header: "PROTECCION DE DATOS", key: "proteccionDatos", width: 22 },
	{ header: "DNI (Verificacion de documentación)", key: "dniVerificacion", width: 26 },
	{ header: "ALTA S.S.", key: "altaSS", width: 18 },
];

const normalizeSheetName = (value) => {
	const cleaned = ["[", "]", ":", "*", "?", "/", "\\"].reduce(
		(accumulator, reservedChar) => accumulator.replaceAll(reservedChar, " "),
		String(value || "AURORA")
	)
		.replace(/\s+/g, " ")
		.trim()
		.toUpperCase();

	return cleaned.slice(0, 31) || "AURORA";
};

const getRowHeight = (row) => {
	const lineCounts = [
		row?.nombreApellidos,
		row?.puedeFichar,
		row?.empresa,
		row?.idNacional,
		row?.proteccionDatos,
		row?.dniVerificacion,
		row?.altaSS,
	].map((value) => String(value || "").split("\n").length);

	return Math.max(36, Math.min(409.6, Math.max(...lineCounts, 1) * 22));
};

const applyHeaderStyles = (worksheet) => {
	worksheet.getRow(1).height = 87;

	worksheet.getRow(1).eachCell((cell) => {
		cell.font = {
			bold: true,
			size: 13,
			name: "Calibri",
			color: { argb: "FF526030" },
		};
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "FFD8E3C0" },
		};
		cell.border = {
			top: { style: "thin", color: { argb: "FF000000" } },
			left: { style: "thin", color: { argb: "FF000000" } },
			bottom: { style: "thin", color: { argb: "FF000000" } },
			right: { style: "thin", color: { argb: "FF000000" } },
		};
		cell.alignment = {
			horizontal: "center",
			vertical: "middle",
			wrapText: true,
		};
	});
};

const applyDataStyles = (rowRef) => {
	rowRef.eachCell((cell) => {
		cell.font = {
			size: 13,
			name: "Calibri",
			color: { argb: "FF000000" },
		};
		cell.alignment = {
			horizontal: "center",
			vertical: "middle",
			wrapText: true,
		};
	});

	const puedeFicharCell = rowRef.getCell(2);
	const puedeFicharValue = String(puedeFicharCell.value || "")
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.trim()
		.toLowerCase();

	if (puedeFicharValue === "si") {
		puedeFicharCell.font = {
			...puedeFicharCell.font,
			color: { argb: "FF4FAD5B" },
		};
	}

	if (puedeFicharValue === "no") {
		puedeFicharCell.font = {
			...puedeFicharCell.font,
			color: { argb: "FFEA3324" },
		};
	}
};

export const createPersonasDocumentacionExcelWorkbook = async ({
	rows = [],
	sheetName = "AURORA",
} = {}) => {
	const excelJsModule = await import("exceljs");
	const ExcelJS = excelJsModule.default || excelJsModule;
	const workbook = new ExcelJS.Workbook();

	workbook.creator = "Plana ETT";
	workbook.lastModifiedBy = "Plana ETT";
	workbook.created = new Date();
	workbook.modified = new Date();

	const worksheet = workbook.addWorksheet(normalizeSheetName(sheetName));
	worksheet.columns = SHEET_COLUMNS.map((column) => ({
		header: column.header,
		key: column.key,
		width: column.width,
	}));

	applyHeaderStyles(worksheet);

	if (!Array.isArray(rows) || rows.length === 0) {
		const emptyRow = worksheet.addRow({
			nombreApellidos: "Sin datos",
			puedeFichar: "",
			empresa: "",
			idNacional: "",
			proteccionDatos: "",
			dniVerificacion: "",
			altaSS: "",
		});
		emptyRow.height = 36;
		applyDataStyles(emptyRow);
		return workbook;
	}

	rows.forEach((row) => {
		const rowRef = worksheet.addRow(row);
		rowRef.height = getRowHeight(row);
		applyDataStyles(rowRef);
	});

	return workbook;
};
